import { Route, Switch } from "react-router-dom";
import ChangeClub from "./ChangeClub";
import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import Link from "app/components/UI/Link";
import PropTypes from "prop-types";
import React from "react";
import classes from "./CurrentClub.module.css";

export const CurrentClub = ({ translate }) => (
  <div className={classes.currentClub}>
    <Flex direction="row" middle className={classes.pageContainer}>
      <Flex direction="row" size={1}>
        <Flex direction="row" size={1} middle className={classes.currentClub__text}>
          <Icon className={classes.icon}>golf_course</Icon>

          <Switch>
            <Route path="/:clubId/" component={ChangeClub} />
            <Route component={() => <span>{translate("Choisissez votre golf Bluegreen")}</span>} />
          </Switch>
        </Flex>
        <Flex direction="row" className={classes.currentClub__text}>
          <Link to="/counter">
            <Icon className={classes.icon}>list_alt</Icon>
            Consulter mon solde
          </Link>
        </Flex>
      </Flex>
    </Flex>
  </div>
);

CurrentClub.propTypes = {
  translate: PropTypes.func.isRequired
};

export default CurrentClub;



// WEBPACK FOOTER //
// ./src/app/components/CurrentClub/CurrentClub.js